import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { baseURL } from "../../BaseUrl"

//fucntion to retrive the token from the local storage
const getToken = () => localStorage.getItem("workManagement")
// API headers including token
const getAuthHeaders = () => ({
   headers:{
    Authorization:`Bearer ${getToken()}`
   }
})
export const getWorkdataByDepartmentID = createAsyncThunk(
    "work/getWorkdataByDepartmentID",
    async (id) => {
      try {
        const response = await baseURL.get(`/work-order/work-order-number-list `,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
    export const qrCodeDownload = createAsyncThunk(
      "qr/qrCodeDownload",
      async (data) => {
        // console.log("dataxsdscd==>",data)
        try {
          const response = await baseURL.post(`/qr-code`, data);
          // console.log("response", response);
          return response.data;
        } catch (error) {
          // console.log(error);
          return error.response.data;
        }
      }
    );
export const printQRSlice = createSlice({
    name:"printQR",
    initialState:{
        workDataByDepartment: [],
        loading:false,
        error:null,
    },
    reducers:{},
    extraReducers:(builder)=>{
        builder
        .addCase(getWorkdataByDepartmentID.pending, (state) => {
          state.loading = true;
        })
        .addCase(getWorkdataByDepartmentID.fulfilled, (state, action) => {
          state.loading = false;
          state.workDataByDepartment = action.payload;
        })
        .addCase(getWorkdataByDepartmentID.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
    }
})
export const getAllWorkDataByDepartment = (state) => state.printQR.workDataByDepartment;
export default printQRSlice.reducer